<h4>Categories</h4>
<button type="button" class="btn btn-secondary btn-sm m-1">Stamping</button>
<button type="button" class="btn btn-secondary btn-sm m-1">Crafts</button>
<button type="button" class="btn btn-secondary btn-sm m-1">Bodycare</button>
<button type="button" class="btn btn-secondary btn-sm m-1">Wares</button>
<button type="button" class="btn btn-secondary btn-sm m-1">Life</button>
<hr/>
